import { d as concatAll, m as map, j as first } from '../../../Either-f9cb4a7c.js';
import { f as flow, a as identity, p as pipe } from '../../../ReadonlyNonEmptyArray-0e481d0b.js';
import { g as getMonoid } from '../../../Record-8960daac.js';
import { b as bimap } from '../../../Tuple-2f69c1c7.js';
import { isObject } from 'lodash';
import { NullValue } from 'ricos-schema';
import { f as firstRight } from '../../../fp-utils-75447caf.js';
import '../../../ReadonlyRecord-86a56753.js';
import '../../../string-40bcd6bf.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const valueM = getMonoid(first());
const toRecord = ([k, v]) => ({ [k]: v });
const toStruct = (fields) => ({ fields });
const toListValue = (values) => ({ values });
const defaultValue = {
  numberValue: void 0,
  nullValue: void 0,
  stringValue: void 0,
  boolValue: void 0
};
const convertJsonToList = (json) => pipe(json, map(convertJsonToValue), toListValue);
const convertJsonToValue = (json) => firstRight(json, __spreadProps(__spreadValues({}, defaultValue), { nullValue: NullValue.NULL_VALUE }), [
  [(json2) => typeof json2 === "number", (json2) => __spreadProps(__spreadValues({}, defaultValue), { numberValue: json2 })],
  [(json2) => typeof json2 === "string", (json2) => __spreadProps(__spreadValues({}, defaultValue), { stringValue: json2 })],
  [(json2) => typeof json2 === "boolean", (json2) => __spreadProps(__spreadValues({}, defaultValue), { boolValue: json2 })],
  [
    (json2) => Array.isArray(json2),
    (json2) => __spreadProps(__spreadValues({}, defaultValue), { listValue: convertJsonToList(json2) })
  ],
  [
    (json2) => isObject(json2),
    (json2) => __spreadProps(__spreadValues({}, defaultValue), { structValue: convertJsonToStruct(json2) })
  ]
]);
const convertJsonToStruct = flow(
  Object.entries,
  map(bimap(convertJsonToValue, identity)),
  map(toRecord),
  concatAll(valueM),
  toStruct
);

export { convertJsonToStruct };
//# sourceMappingURL=convertJsonToStruct.js.map
